import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { BrandingService } from '../services/branding.service';

export const kioskGuard: CanActivateFn = () => {
  const brandingService = inject(BrandingService);
  const router = inject(Router);

  return brandingService.kioskFormAvailable$.pipe(
    map(isAvailable => isAvailable ? true : router.createUrlTree(['/']))
  );
};
